import * as d3 from "d3";
import CallItem, {serviceCallItemConstants} from './ServiceCallItem'
import Scale from "./Scale";
import Label from "./Label";
import Grid from "./Grid";

import "./Visualisation.css"


const width = 800;
const height = 700;

const margin = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 100
};

const layout = {
    labels: [width * .2, height * .9],
    plot: [width * .8, height * .9],
    scale: [width * .8, height * .1]
}

const ServiceCallsVisualisation = ({data}) => {
    const xScale = d3.scaleLinear()
        .domain([0, d3.max(data, d => d.start + d.duration)])
        .range([0, layout.plot[0]])
        .interpolate(d3.interpolateRound)

    const yScale = d3.scaleBand()
        .domain(data.map(d => d.id))
        .range([0, data.length * serviceCallItemConstants.height])
        .padding(0.0)
        .round(true)

    const serviceColor = d3.scaleOrdinal(d3.schemePastel2)
        .domain(data.map(d => d.name))

    return <div className="visualisation-container">
        <svg viewBox={`${margin.right} ${margin.top} ${width} ${height - margin.top}`}
             style={{maxWidth: `${width}px`,}}>

            <g
                key={"labels"}
                transform={`translate(${layout.labels[0] - 10})`}
            >
                {data.map(callData => <Label
                    key={callData.id}
                    callData={callData}
                    yScale={yScale}
                />)}
            </g>

            <g
                key={"plot"}
                transform={`translate(${layout.labels[0]})`}
            >
                <Grid x={xScale} y1={yScale(0)} y2={yScale((data[data.length - 1]).id) + yScale.step()} tickCount={8} />
                {data.map(callData => <CallItem
                    key={callData.id}
                    callData={callData}
                    serviceColor={serviceColor}
                    yScale={yScale}
                    xScale={xScale}
                />)}
            </g>
            <g
                key={"scale"}
                transform={`translate(${layout.labels[0]} ${yScale((data[data.length - 1]).id) + yScale.step()})`}
            >
                <Scale x={xScale} tickCount={8}/>
            </g>

        </svg>
    </div>
}

export default ServiceCallsVisualisation
